import { DialogContent } from '@mui/material';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const StyledDialogContent = styled(DialogContent)`
  max-width: 450px;
  padding: 16px !important;
`;
